import api from './index';

const prefix = '/web/reagent-accounting';
const options = { localError: true };
const segment = value => encodeURIComponent(value);
export const getAccounts = () => api.get(`${prefix}/accounts`, options);
export const getAccount = id => api.get(`${prefix}/accounts/${segment(id)}`, options);
export const getLedger = (id, after = 0) => api.get(`${prefix}/accounts/${segment(id)}/ledger`, { ...options, params: { after, limit: 100 } });
export const getReconciliation = (id, cutoff) => api.get(`${prefix}/accounts/${segment(id)}/reconciliation`, { ...options, params: { cutoff } });
export const getMonthly = (id, month) => api.get(`${prefix}/accounts/${segment(id)}/monthly`, { ...options, params: { month } });
export const getCases = id => api.get(`${prefix}/accounts/${segment(id)}/cases`, options);
export const getPackaging = productId => api.get(`${prefix}/packaging/${segment(productId)}`, options);
export const getOperation = key => api.get(`${prefix}/operations`, { ...options, params: { key } });
export const getControl = device => api.get(`/web/device-control/${segment(device)}`, options);
export const getControlAudit = device => api.get(`/web/device-control/${segment(device)}/audit`, options);
export const submitAccounting = (path, payload) => api.post(`${prefix}/${path}`, payload, options);
export const submitControl = payload => api.post('/web/device-control/reagent', payload, options);

export function accountingError(error) {
  if (error.response?.status === 404) return '接口未开放：请确认后端已完成数据库迁移并启用试剂供用模块。';
  return error.response?.data?.msg || error.message || '请求失败，请重试';
}
